// 1977 Topps Star Wars Series 5 — GENERATED by pipeline-publish (2026-05-30)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/1977-series-5.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "1977-series-5",
//     name: "1977 Topps Star Wars Series 5",
//     shortName: "Series 5 1977",
//     year: 1977,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "1977",
//     totalCards: 77,
//     description: "Topps 1977 Topps Star Wars Series 5 trading card set.",
//     color: "#888aa0",
//     accentColor: "#f0c040",
//     dataFile: "1977-series-5",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [],
    cards: [
        { n: "265", name: "Anxious Moments for the Rebels" },
        { n: "266", name: "Threepio and Leia Monitor the Battle" },
        { n: "267", name: "No-Nonsense Privateer Han Solo!" },
        { n: "268", name: "Ben Prepares to Turn Off the Tractor Beam" },
        { n: "269", name: "Droids on the Run!" },
        { n: "270", name: "Luke: Farmboy Turned Warrior!" },
        { n: "271", name: "\"Do You Think They'll Melt Us Down, Artoo?\"" },
        { n: "272", name: "Corridors of the Death Star" },
        { n: "273", name: "\"This is All Your Fault Artoo!\"" },
        { n: "274", name: "Droids Trick the Stormtroopers!" },
        { n: "275", name: "Guarding the Millennium Falcon" },
        { n: "276", name: "It's Not Wise to Upset a Wookiee!" },
        { n: "277", name: "Bizarre Inhabitants of the Cantina" },
        { n: "278", name: "a Narrow Escape!" },
        { n: "279", name: "Awaiting the Imperial Attack" },
        { n: "280", name: "\"Remember Luke, the Force Will Be With You\"" },
        { n: "281", name: "A Monstrous Thirst!" },
        { n: "282", name: "\"Hurry Up, Luke We're Gonna Have Company!\"" },
        { n: "283", name: "The Cantina Musicians" },
        { n: "284", name: "Distracted by Solo's Assault" },
        { n: "285", name: "Spiffed Up for the Awards Ceremony" },
        { n: "286", name: "Cantina Denizens" },
        { n: "287", name: "Han and Chewie Ready for Action!" },
        { n: "288", name: "Blasting the Enemy!" },
        { n: "289", name: "The Rebel Fighters Take Off!" },
        { n: "290", name: "Chewie Aims for Danger!" },
        { n: "291", name: "Lord Vader Senses the Force" },
        { n: "292", name: "The Stormtroopers Assemble" },
        { n: "293", name: "A Friendly Chat Among Alien Friends!" },
        { n: "294", name: "Droids Make Their Way to the Escape Pod" },
        { n: "295", name: "Han and the Rebel Pilots" },
        { n: "296", name: "Artoo-Detoo is Abducted by Jawas!" },
        { n: "297", name: "Inside the Sandcrawler" },
        { n: "298", name: "Chewie Gets Riled!" },
        { n: "299", name: "Leia Wishes Luke Good Luck!" },
        { n: "300", name: "Luke, the Star Warrior!" },
        { n: "301", name: "A Crucial Moment for Luke Skywalker" },
        { n: "302", name: "Threepio and Artoo" },
        { n: "303", name: "Various Droids Collected by the Jawas" },
        { n: "304", name: "The Jawas Ready Their Merchandise" },
        { n: "305", name: "Director George Lucas and \"Greedo\"" },
        { n: "306", name: "Technicians Ready C-3P0 for the Cameras" },
        { n: "307", name: "A Touch-Up for Chewbacca!" },
        { n: "308", name: "Directing the Cantina Creatures" },
        { n: "309", name: "The Birthday Celebration for Sir Alec Guinness" },
        { n: "310", name: "Filming the Awards Ceremony" },
        { n: "311", name: "The Model Builders Proudly Display Their Work" },
        { n: "312", name: "Using the \"Blue Screen\" Process for X-Wings" },
        { n: "313", name: "The Birth of a Droid" },
        { n: "314", name: "Shooting in Tunisia" },
        { n: "315", name: "Inside the Millennium Falcon" },
        { n: "316", name: "Photographing the Miniature Explosions" },
        { n: "317", name: "Filming Explosions on the Death Star" },
        { n: "318", name: "\"Make-up\" for the Bantha" },
        { n: "319", name: "Dave Prowse and Alex Guinness Rehearse" },
        { n: "320", name: "Flight of the Falcon" },
        { n: "321", name: "George Lucas Directs his Counterpart \"Luke\"" },
        { n: "322", name: "Constructing the Star Destroyer" },
        { n: "323", name: "Aboard the Millennium Falcon" },
        { n: "324", name: "Chewie Takes a Breather Between Scenes" },
        { n: "325", name: "The Princess Gets the Brush!" },
        { n: "326", name: "Animating the \"Chessboard\" Creatures" },
        { n: "327", name: "Filming the Sandcrawler" },
        { n: "328", name: "X-Wings Positioned for the Cameras" },
        { n: "329", name: "Sir Alec Guinness and George Lucas" },
        { n: "330", name: "Filming Luke and Threepio in Tunisia" },
    ],
  },
  {
    id: "sticker",
    type: "insert",
    title: "STICKER",
    parallels: [],
    cards: [
        { n: "45", name: "A Crucial Moment for Luke Skywalker" },
        { n: "46", name: "Chewie Gets Riled!" },
        { n: "47", name: "Threepio and Artoo" },
        { n: "48", name: "Various Droids Collected by the Jawas" },
        { n: "49", name: "Luke, Star Warrior!" },
        { n: "50", name: "Director George Lucas and Greedo" },
        { n: "51", name: "Technicians Ready C-3P0 for the Cameras" },
        { n: "52", name: "The Jawas Ready Their New Merchandise" },
        { n: "53", name: "Directing the Cantina Creatures" },
        { n: "54", name: "Leia Wishes Luke Good Luck" },
        { n: "55", name: "A Touch-up For Chewbacca!" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
